import { useTranslation } from "react-i18next";
import type { BillOut } from "../../../../../api/bills";
import { appliedBillDiscount } from "./billAmountDiscount";

interface BillAmountDiscountBannerProps {
  bill: Pick<BillOut, "bill_discount_applied">;
  /** Тесен екран — по-дребни кегели и отстъпи. */
  compact?: boolean;
  /** Хоризонталният падинг го дава РОДИТЕЛЯТ — като `BillCustomerBanner`. */
  className?: string;
}

/** Лента „Отстъпка на цялата сметка −X €" — до лентата на клиента в
 *  „Закрий": редовете отдолу са със сумите си, а сумата на масата е вече без
 *  отстъпката. Само при такава. */
export const BillAmountDiscountBanner = ({
  bill,
  compact = false,
  className = "",
}: BillAmountDiscountBannerProps) => {
  const { t } = useTranslation();
  const amount = appliedBillDiscount(bill);
  if (amount < 0.005) return null;
  return (
    <div
      className={`flex items-center border-b border-pos-line2 bg-pos-marked text-pos-ink ${
        compact ? "gap-2.5 py-1.5" : "gap-3 py-2"
      } ${className}`}
    >
      <span
        className={`inline-flex shrink-0 items-center rounded-lg bg-pos-disc-bg font-pos-mono font-bold leading-none text-pos-disc-ink ${
          compact ? "h-6 px-2 text-[12px]" : "h-7 px-2.5 text-sm"
        }`}
      >
        −{amount.toFixed(2)} €
      </span>
      <span
        className={`min-w-0 flex-1 truncate font-extrabold leading-tight text-pos-ink ${
          compact ? "text-[13px]" : "text-[15px]"
        }`}
      >
        {t("itemDiscounts.billTitle")}
      </span>
    </div>
  );
};
